import { ThemeImages } from '../utilities/branding';
import hmktsLogo from './hmkts_logo.png';
import hmktsLoginLogo from './LoginLogo.png';
import hmktsLoginBackground from './LoginBackground.jpg';
import hmktsFavicon from './favicon.png';
import hmktsBubblesPrimary from './bubbles_green.png';
import hmktsBubblesSecondary from './bubbles_blue.png';
import hmktsBubblesTertiary from './bubbles_orange.png';
import excelsiorLogo from './excelsior_logo.png';
import excelsiorLoginLogo from './LoginLogo_Excelsior.png';
import excelsiorFavicon from './favicon_Excelsior.png';

export const BrandingAssets: { [key: string]: ThemeImages } = {
	HealthMarkets: {
		logo: hmktsLogo,
		loginLogo: hmktsLoginLogo,
		loginBackground: hmktsLoginBackground,
		favicon: hmktsFavicon,
		bubblesPrimary: hmktsBubblesPrimary,
		bubblesSecondary: hmktsBubblesSecondary,
		bubblesTertiary: hmktsBubblesTertiary,
	},
	Excelsior: {
		logo: excelsiorLogo,
		loginLogo: excelsiorLoginLogo,
		loginBackground: '',
		favicon: excelsiorFavicon,
		bubblesPrimary: '',
		bubblesSecondary: '',
		bubblesTertiary: '',
	},
};